module.exports = __webpack_public_path__ + "img/4@2x.afcf556c.jpg";